import React from 'react';
import { Alert, Button, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import useAppVersionWatcher from '../hooks/useAppVersionWatcher';

// "A new version of the portal is available" notice. Persistent (no auto-hide,
// no click-away close) and dismissible; a dismissed notice comes back after 30
// minutes. Reload is always the user's decision — never automatic.
export default function AppUpdateNotice() {
  const { t } = useTranslation();
  const { visible, dismiss } = useAppVersionWatcher();

  return (
    <Snackbar open={visible} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert
        severity="info"
        variant="filled"
        action={
          <>
            <Button color="inherit" size="small" onClick={() => window.location.reload()}>
              {t('portal_update_reload', { defaultValue: 'Reload' })}
            </Button>
            <IconButton aria-label={t('close_message', { defaultValue: 'Close message' })} color="inherit" size="small" onClick={dismiss}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </>
        }
      >
        {t('portal_update_available', { defaultValue: 'A new version of the portal is available.' })}
      </Alert>
    </Snackbar>
  );
}
